import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

//import general components
import EmptyOrErrorState from "../../common/empty-or-error-state/empty-or-error-state";

//import view components
import CountryTourItem from "./country-tour-item";

//import images and icons
import { InfoCircle } from "iconsax-react";
import springImage from "../../../assets/imgs/tour/spring/spring.jpg";
import winterImage from "../../../assets/imgs/tour/winter/winter.jpg";

export default function CountryTourList() {
    const { t } = useTranslation();

    const tourList = [
        {
            id: 1,
            title: "Circuit de 17 jours en Iran",
            country: "Iran",
            cities: ["Téhéran", "Yazd", "Ispahan", "Chiraz", "Qeshm"],
            image: winterImage,
            departureDate: "Hiver 2026–2027",
            duration: "17 jours",
            transport: "flight",
            hotel: "Hôtel 5 étoiles",
            price: 48500000,
            currency: "euro",
            tourType: "groupTour",
        },
        {
            id: 2,
            title: "Circuit de 14 jours en Iran",
            country: "Iran",
            cities: ["Téhéran", "Rasht", "Chiraz", "Yazd", "Ispahan", "Kashan"],
            image: springImage,
            departureDate: "Printemps 2027",
            duration: "14 jours",
            transport: "flight",
            hotel: "Hôtel 5 étoiles",
            price: 48500000,
            currency: "euro",
            tourType: "groupTour",
        },
    ];
    return (
        <Grid container item xs={12} rowGap={4} columnGap={4} justifyContent={{ xs: "center", md: "flex-start" }}>
            {tourList?.length ? (
                tourList?.map(tourItem => {
                    return (
                        <Grid key={tourItem.id} container item md={3.7}>
                            <CountryTourItem tour={tourItem} />
                        </Grid>
                    );
                })
            ) : (
                <EmptyOrErrorState
                    title={t("Messages.No Tours Available")}
                    icon={<InfoCircle size="32" color="var(--secondary-color)" variant="Bold" />}
                />
            )}
        </Grid>
    );
}
